"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NavBar;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _episourceColor = _interopRequireDefault(require("../../themes/episourceColor"));
const useStyles = (0, _styles.makeStyles)(theme => ({
  nav: {
    'height': '80px',
    'marginTop': '-5px',
    '& ul': {
      'margin': 0,
      'height': '80px',
      '& li': {
        'display': 'inline-flex',
        'padding': theme.spacing(0, 3),
        'height': '77px',
        '& a': {
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: _episourceColor["default"].iconDefault,
          textDecoration: 'none',
          textTransform: 'uppercase',
          fontSize: '16px',
          fontWeight: 'normal'
        }
      },
      '& li.active, & li:hover': {
        background: _episourceColor["default"].textContrast,
        color: _episourceColor["default"].epiAnalystPrimaryDark
      },
      '& li.active': {
        'borderBottom': '5px solid',
        'borderBottomColor': _episourceColor["default"].epiAnalystPrimaryDark,
        '& a span': {
          color: _episourceColor["default"].epiAnalystPrimaryDark
        }
      }
    }
  }
}));
function NavBar(_ref) {
  let {
    items = []
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: classes.nav
  }, /*#__PURE__*/_react["default"].createElement("ul", null, items.map(item => /*#__PURE__*/_react["default"].createElement("li", {
    className: item.active ? 'active' : ''
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: item.url
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "button"
  }, item.name))))));
}
NavBar.defaultProps = {
  items: []
};